import Vue from 'vue';
import Router from 'vue-router';
import BreakTheGlassRequest from '@/views/BreakTheGlassRequest';
import ErrorPage from '@/views/ErrorPage';
import Forbidden from '@/views/Forbidden';
import LandingPage from '@/views/LandingPage';
import LoggedOut from '@/views/LoggedOut';
import NewProject from '@/views/NewProject';
import Projects from '@/views/Projects';
import Reports from '@/views/Reports';
import {authService} from '@/authService';
import routerUtil from './util';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      // DEPRECATED ROUTE NAME: Kept to accommodate existing links as of 07/07/2021
      path: '/request-project',
      redirect: '/new-project',
    },
    {
      path: '/new-project',
      name: 'NewProject',
      component: NewProject,
      meta: {
        requiresAuth: true,
      },
    },
    {
      // DEPRECATED ROUTE NAME: Kept to accommodate existing links as of 07/07/2021
      path: '/project-status',
      redirect: '/projects',
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/logged-out',
      name: 'LoggedOut',
      component: LoggedOut,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/error/:errorMessage',
      name: 'error',
      component: ErrorPage,
      meta: {
        requiresAuth: false,
      },
      props: true,
    },
    {
      path: '/reports',
      name: 'Reports',
      component: Reports,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/break-the-glass-request',
      name: 'BreakTheGlassRequest',
      component: BreakTheGlassRequest,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.path === '/auth/callback') {
    authService.signinRedirectCallback().then(() => {
      const referredBy = routerUtil.getAndClearReferredBy();
      next(referredBy);
      return;
    });
  }

  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);
  if (requiresAuth) {
    authService.getUser().then(
      (user) => {
        if (!user) {
          if (!to.path.startsWith('/auth/callback')) {
            routerUtil.saveReferredBy(to);
          }
          authService.login();
        } else {
          next();
        }
      },
      (err) => {
        console.log(err);
      }
    );
  } else {
    next();
  }
});

export default router;
